// extracted by css-extract-rspack-plugin
export default {"empty":"empty-Czbdy1","image":"image-YbxMeR"};